<template>
  <info-header-card :icon="analyte.icon()" :header="header" :rows="rows">
    <template #SampleType v-if="sample_type">
      <a :href="`#/sampletypes/${sample_type.id}`" class="btn-link">
        {{ sample_type.name }}
      </a>
    </template>
  </info-header-card>
</template>

<script>
import AnalyteModel from "@/models/lab/AnalyteModel";
import InfoHeaderCard from "@/components/shared/InfoHeaderCard";

export default {
  name: "AnalyteCard",
  components: {
    InfoHeaderCard,
  },
  props: {
    analyte: {
      type: Object,
      default: () => new AnalyteModel(),
    },
  },
  computed: {
    sample_type() {
      return this.analyte.sample_type && this.analyte.getSampleType();
    },
    header() {
      return this.analyte.name;
    },
    rows() {
      return [
        {
          label: "Sample Type",
          value: this.sample_type ? this.sample_type.name : null,
        },
        {
          label: "Abbreviation",
          value: this.analyte.abbrev,
        },
        {
          label: "MODUS Name",
          value: this.analyte.modus_name,
        },
        {
          label: "Description",
          value: this.analyte.description,
        },
        {
          label: "Range Min",
          value: this.analyte.range_min,
        },
        {
          label: "Range Max",
          value: this.analyte.range_max,
        },
        {
          label: "Grind Key",
          value: this.analyte.grind_key,
        }
      ];
    },
  },
};
</script>
